export default __webpack_public_path__ + "static/media/pic8.bb986f15.jpg";